/**
 * Contact stages come back from the APIs display-cased ("Not Contacted",
 * "Opted Out"), not as the SCREAMING_SNAKE constants the findings rules
 * compare against. Normalize before comparing.
 */
const stageKey = stage =>
  String(stage || "")
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_");

export default stageKey;
